import { css } from 'styled-components';
import siteStageColors from './siteStageColors';

const colorItemContainerStyles = () => css`
    background-color: ${({ theme }) => siteStageColors.siteStageLightest(theme)};
`;

export default colorItemContainerStyles;
